<template lang="pug">
div
  section.u-mt-md
    AppTitle(:title="$t('mantra')")



  section.u-mt-md
    .grid
      .column.is-widescreen-4.is-tablet-6
        AppCard.is-large( :img="[{ srcset: '{CDN_URL}/new/resources/freebies@2x.webp 2x, {CDN_URL}/new/resources/freebies.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/new/resources/freebies@2x.png 2x, {CDN_URL}/new/resources/freebies.png 1x', type: 'image/png' }]" :excerpt="$t('freebiesDesc')" ratio="1:1" :title="$t('freebies')" :url="`/freebies`")
      .column.is-widescreen-4.is-tablet-6
        AppCard.is-large( :img="[{ srcset: '{CDN_URL}/new/resources/books@2x.webp 2x, {CDN_URL}/new/resources/books.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/new/resources/books@2x.png 2x, {CDN_URL}/new/resources/books.png 1x', type: 'image/png' }]" :excerpt="$t('booksDesc')" ratio="1:1" :title="$t('books')" :url="`/books`")
      .column.is-widescreen-4.is-tablet-6
        AppCard.is-large( :img="[{ srcset: '{CDN_URL}/new/resources/opensource@2x.webp 2x, {CDN_URL}/new/resources/opensource.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/new/resources/opensource@2x.png 2x, {CDN_URL}/new/resources/opensource.png 1x', type: 'image/png' }]" :excerpt="$t('openSourceDesc')" ratio="1:1" :title="$t('openSource')" :url="`/openSource`")
      .column.is-widescreen-4.is-tablet-6
        AppCard.is-large( :img="[{ srcset: '{CDN_URL}/home/tools@2x.webp 2x, {CDN_URL}/home/tools.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/home/tools@2x.png 2x, {CDN_URL}/home/tools.png 1x', type: 'image/png' }]" :excerpt="$t('toolsDesc')" ratio="1:1" :title="$t('tools')" :url="`/tools`")
      //- .column.is-widescreen-4.is-tablet-6
      //-   AppCard.is-large( :img="[{ srcset: '{CDN_URL}/fonts@2x.webp 2x, {CDN_URL}/fonts.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/fonts@2x.png 2x, {CDN_URL}/fonts.png 1x', type: 'image/png' }]" :excerpt="$t('fontsDesc')" ratio="1:1" :title="$t('fonts')" :url="`/typefaces`")

  .u-divider.u-mt-sm

  section.u-mt-md
    .grid.is-small.is-middle
      .column.is-desktop-4
        AppCard.is-large( :img="[{ srcset: '{CDN_URL}/academy@2x.webp 2x, {CDN_URL}/academy.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/academy@2x.png 2x, {CDN_URL}/academy.png 1x', type: 'image/png' }]" :excerpt="$t('academyDesc')" ratio="1:1" :title="$t('academy')" :url="`/academy`")
      .column.is-desktop-1
      .column.is-desktop-6
        AppCard.is-large( :img="[{ srcset: '{CDN_URL}/labs@2x.webp 2x, {CDN_URL}/labs.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/labs@2x.png 2x, {CDN_URL}/labs.png 1x', type: 'image/png' }]" :excerpt="$t('labsDesc')" ratio="2:1" :title="$t('labs')" :url="`/labs`")


  .u-mb-mi
</template>

<script>
import { Resources } from '~/graphql/Resource.gql';
import Query from '~/components/Query';

export default {
  scrollToTop: true,
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        }
      ]
    };
  },
  components: {
    Query
  },
  async asyncData({ app }) {
    const { data } = await app.$api.query({
      query: Resources,
      variables: {
        type: 'FREEBIE',
        first: 6
      }
    });

    return { ...data, isFetching: false };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Baianat Resources",
    "pageDesc":"Get inspired and create your own unique designing style with resources that can be downloaded and used right away.",
    "mantra":"Inspiring resources |for creatives.",
    "designResources":"Design resources",
    "tools":"Tools",
    "toolsDesc":"Variety of handy tools to help you get your work done faster. Use it online and download the results in the format your prefer.",
    "fonts":"Typefaces",
    "fontsDesc":"Make beautiful designs using fonts that blend smoothly with your identity.",
    "openSource":"Open source",
    "openSourceDesc":"Baianat libraries created to support developers in their coding process and cut off the time needed for mobile or web development processes.",
    "books": "Books",
    "booksDesc":"Explore Baianat library of books and guides. Get to know the what and how of design, business, code and technology.",
    "freebies":"Freebies",
    "freebiesDesc":"Get inspired and create your own unique designing style with freebies that can be downloaded and used right away.",
    "labs":"Labs",
    "labsDesc":"Enjoy Baianat educational materials in different fields from courses to books, podcasts, articles and more.",
    "academy":"Academy",
    "academyDesc":"Learning paths in design, business, development and technology."



  },
  "ar": {
    "pageTitle":"تصميمات مجانية",
    "pageDesc":"توفر بيانات مجموعة من المصادر التي تعمل على إلهامك في أعمالك مثل الأيقونات وواجهات المستخدم والباترن والقوالب..وغيرها.",
    "mantra":"مصادر مُلهمة من |أجل تصميماتك.",
    "designResources":"مصادر التصميم",
    "fonts":"الخطوط",
    "fontsDesc":"اصنع تصميمات جميلة باستخدام خطوط تتماشى بسلاسة مع هويتك.",
    "tools":"الأدوات",
    "toolsDesc":"مجموعة متنوعة من الأدوات التي تساعدك على إنجاز أعمالك بشكل أسرع. استخدمها عبر الانترنت ثم قم بتحميل النتائج على الفور.",
    "openSource":"المصادر المفتوحة",
    "openSourceDesc":"تم إنشاء المصادر المفتوحة من أجل دعم المبرمجين في عملياتهم وتقليل الوقت والمجهود سواء لمبرمجى التطبيقات أو الويب.",
    "books": "الكتب",
    "booksDesc":"اكتشف مكتبة بيانات للكتب المتنوعة و التي تتضمن مواضيع حول التصميم و الأعمال التجارية و البرمجة والتكنولوجيا والأنيميشن.",
    "freebies":"المصادر",
    "freebiesDesc":"توفر بيانات مجموعة من المصادر التي تعمل على إلهامك في أعمالك مثل الأيقونات وواجهات المستخدم والباترن والقوالب..وغيرها.",
    "labs":"المختبرات",
    "labsDesc":"الآن يمكنك الوصول إلى المزيد من الأدوات، والمقالات و الموارد المفيدة في مجالات التكنولوجيا والتصميم والبرمجة و الأعمال التجارية. ",
    "academy":"الأكاديمية",
    "academyDesc":"مسارات التعلم في التصميم والأعمال التجارية والبرمجة والتكنولوجيا."

  }
}
</i18n>
